<template>
  <div class="menu-wrapper">
    <div :class="['menu', openMenu ? 'open' : 'close']">
      <div class="hamburger-menu">
        <div :class="['hamburger', { open: openMenu}]" @click="openMenu = !openMenu">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      <ul class="menu-options">
        <li class="advertiser-account">
          <div @click="toggleAccounts = !toggleAccounts" :class="['current-account', toggleAccounts ? 'up-arrow' : 'down-arrow', {['menu-link']: multiAccountUser}]">{{currentAdvertiser.name}}</div>
          <ul v-if="multiAccountUser" >
            <li v-for="advertiser in userAdvertisers"
                :key="advertiser.id"
                :class="['accounts', toggleAccounts ? 'slide-down' : 'slide-up', {selected: advertiser.id === currentAdvertiser.id}]"
                @click="changeAdvertiser(advertiser.id)">
              {{advertiser.name}}
            </li>
          </ul>
        </li>
        <li>
          <router-link to="/" exact class="menu-link">
            <div class="menu-icon-wrapper">
              <svg class="speaker-icon" viewBox="0 0 600 600">
                <use xlink:href="#speaker-icon" width="22px" height="22px"/>
              </svg>
            </div>
            ads
          </router-link>
          <router-link to="/autoconnects" exact class="menu-link">
            <fai :icon="['fas', 'redo-alt']" class="fai-spacing"/>
            autoconnects
          </router-link>
          <router-link to="/insights" exact class="menu-link">
            <div class="menu-icon-wrapper">
              <svg class="report-icon" viewBox="0 0 600 600">
                <use xlink:href="#report-icon" width="22px" height="22px"/>
              </svg>
            </div>
            insights
          </router-link>
          <router-link to="/files" exact class="menu-link">
            <div class="menu-icon-wrapper">
              <svg class="files-icon" viewBox="0 0 600 600">
                <use xlink:href="#files-icon" width="22px" height="22px"/>
              </svg>
            </div>
            files
          </router-link>
          <router-link to="/credits" exact class="menu-link">
            <fai :icon="['fas', 'paper-plane']" class="fai-spacing"/>
            credits
          </router-link>
          <router-link to="/settings" exact-path class="menu-link">
            <div class="menu-icon-wrapper">
              <svg class="settings-icon" viewBox="0 0 600 600">
                <use xlink:href="#settings-icon" width="22px" height="22px"/>
              </svg>
              <img v-if="hasSuggestedTags" class="notification-img" src="@/assets/images/notification_suggested_tag.png" alt="suggested-tag-notification">
            </div>
            settings
          </router-link>
        </li>
        <li>
          <a href="#" class="menu-link logout" @click.prevent="logout">
            <svg class="door-icon" viewBox="0 0 600 600">
              <use xlink:href="#door-icon" width="22px" height="22px"></use>
            </svg>
            logout
          </a>
        </li>

        <li v-if="currentAdvertiser.admin">
          <router-link :to="'/admin'" class="menu-link admin-dashboard">
            admin dashboard
          </router-link>
        </li>

        <li v-if="currentAdvertiser.access_to == 'both'">
          <router-link :to="'/retailer'" class="menu-link retailer-platform">
            retailer platform
          </router-link>
        </li>
      </ul>
    </div>
    <div v-show="showNotification" class="suggested-tag-notification hide-up-to-tablet">
      you have new suggested tags.
      <router-link to="/settings/tag-settings" class="claim-tag-link">
        click here to claim
      </router-link>
    </div>
    <img
      :class="['wrapper-notification', 'hide-down-to-tablet', {'hide-notification-icon' : openMenu || !showNotification}]"
      src="@/assets/images/notification_suggested_tag.png"
      alt="suggested-tag-notification">
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import router from '../../router/router'

  export default {
    props: {
      userAdvertisers: Array,
      currentAdvertiser: Object,
    },

    name: 'NavMenu',

    data() {
      return {
        openMenu: false,
        multiAccountUser: this.userAdvertisers.length > 1,
        toggleAccounts: false
      }
    },

    computed: {
      showNotification() {
        return this.hasSuggestedTags && (this.$route.path !== '/settings/tag-settings')
      },
      ...mapState([
        'brand',
        'userId'
      ]),
      ...mapGetters([
        'hasSuggestedTags'
      ])
    },

    methods: {
      changeAdvertiser(id) {
        localStorage.setItem('a_id', id)
        this.$route.name === 'Dashboard' ? window.location.reload() : window.location.replace('/')
      },

      logout() {
        localStorage.clear()
        router.push({path:'/logout'})
      }
    },

    watch: {
      '$route' (to, from) {
        this.openMenu = false
      }
    }
  }
</script>

<style lang="sass">
@import '../../assets/sass/colors'

.menu
  position: relative
  background: $primary-color
  border-radius: 0 7px 7px 7px
  display: inline-block
  z-index: 8

  &.open
    background: #deeefe
    transition: background .5s

  &.close
    font-size: 0
    margin: 0
    padding: 0
    height: auto
    width: auto
    transition: background .5s

  &.close svg
    visibility: hidden

.hamburger-menu
  padding: 8px 8px 3px 8px

.menu.close .menu-options *
  opacity: 0
  padding: 0
  list-style-type: none
  margin: 0
  font-size: 0
  height: 0
  width: 0

.menu.open .menu-options *
  opacity: 1
  transition: margin .1s, padding .1s, opacity .25s .25s

.menu.open .menu-options
  padding: .5rem 2rem

  .admin-dashboard, .retailer-platform
    font-size: 11px
    justify-content: center

.advertiser-account
  .current-account
    margin-bottom: 1rem
    &.menu-link
      cursor: pointer
      color: #000
      &:hover
        color: $primary-color
        &:after
          border-bottom: 1px solid $primary-color
          border-right: 1px solid $primary-color
      &:after
        border-bottom: 1px solid #000
        border-right: 1px solid #000
        content: ' '
        display: inline-block
        height: 6px
        width: 6px

      &.down-arrow
        &:after
          margin: .25rem 0 .25rem .75rem
          transform: rotate(45deg)

      &.up-arrow
        &:after
          margin: .5rem 0 0 .75rem
          transform: rotate(-135deg)

  ul
    margin-top: -10px

  .accounts
    color: #000
    cursor: pointer
    margin: .75rem .5rem
    opacity: 1

    &:hover,
    &.selected
      color: $primary-color

    &.selected
      pointer-events: none

    &.slide-up
      font-size: 0
      margin: 0
      opacity: 0
      padding: 0
      transition: opacity .25s, font-size .5s .25s, margin .75s .25s, padding .5s .25s

    &.slide-down
      transition: font-size .25s, margin .25s, padding .25s, opacity .5s .25s

.hamburger
  cursor: pointer
  height: 35px
  position: relative
  margin-right: 0
  -webkit-transform: rotate(0deg)
  -moz-transform: rotate(0deg)
  -o-transform: rotate(0deg)
  transform: rotate(0deg)
  transition: .5s ease-in-out
  width: 40px

.hamburger span
  background: #fff
  border-radius: 9px
  display: block
  height: 4px
  left: 0
  opacity: 1
  position: absolute
  -webkit-transform: rotate(0deg)
  -moz-transform: rotate(0deg)
  -o-transform: rotate(0deg)
  transform: rotate(0deg)
  transition: .25s ease-in-out
  width: 100%

.hamburger span:nth-child(1)
  top: 0px

.hamburger span:nth-child(2),.hamburger span:nth-child(3)
  top: 12px

.hamburger span:nth-child(4)
  top: 24px

.hamburger.open
  height: 20px
  width: 15px

.hamburger.open span
  background: $primary-color
  height: 1px

.hamburger.open span:nth-child(1) , .hamburger.open span:nth-child(4)
  width: 0%

.hamburger.open span:nth-child(2)
  -webkit-transform: rotate(45deg)
  -moz-transform: rotate(45deg)
  -o-transform: rotate(45deg)
  transform: rotate(45deg)

.hamburger.open span:nth-child(3)
  -webkit-transform: rotate(-45deg)
  -moz-transform: rotate(-45deg)
  -o-transform: rotate(-45deg)
  transform: rotate(-45deg)

.menu svg
  fill: #000
  height: 22px
  width: 22px

.menu-link
  display: flex
  padding: .5rem 0

  svg
    padding-right: 5px

  .fai-spacing
    padding-right: 10px
    height: 18px
    width: 18px

  .menu-icon-wrapper
    position: relative
    .notification-img
      left: -6px
      position: absolute
      top: -6px
      width: 13px

a
  text-decoration: none
  color: #000
  &:hover
    color: $primary-color
    svg
      fill: $primary-color

  &.router-link-active
    color: $primary-color
    svg
      fill: $primary-color

.menu-wrapper
  display: flex
  position: absolute
  top: 0
  .suggested-tag-notification
    background-color: #fff
    border: 1px solid red
    border-radius: 8px
    font-size: .85em
    height: fit-content
    left: 14px
    margin-top: 5px
    padding: .7em
    position: relative
    z-index: 8
    &::before, &::after
      content: ''
      height: 0
      position: absolute
      width: 0
    &::before
      left: 0
      top: 50%
      border: 15.5px solid
      border-left: 0
      border-top: 0
      margin: -10px auto auto -16px
      border-color: red red transparent red
    &::after
      left: 0
      top: 50%
      border: 14px solid
      border-left: 0
      border-top: 0
      margin: -8.55px auto auto -13px
      border-color: #fff #fff transparent #fff
    .claim-tag-link
      text-decoration: underline
  .wrapper-notification
    left: -10px
    height: 20px
    position: relative
    width: 20px
    z-index: 10
  .hide-notification-icon
    visibility: hidden
</style>
